import React from 'react';

export default function LoadingReset() {
  return <div className="loading p-relative" />;
}
